import { render, staticRenderFns } from "./scopecity.vue?vue&type=template&id=54f875b5&"
import script from "./scopecity.vue?vue&type=script&lang=js&"
export * from "./scopecity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports